import axios from "../config/axios-chatbot";

export const RESPONSE_TIME_TYPES = ["SPEECH_TO_TEXT", "TEXT_TO_SPEECH", "CHATBOT", "ACTIVE_CALLS"];

// window: how much time a response-time card shows; step: how far the chevrons move it (half a window)
export const STATISTIC_PERIODS = [
    {
        value: "MINUTES", label: "Minute", windowLabel: "Last hour",
        window: {amount: 60, unit: "minutes"}, step: {amount: 30, unit: "minutes"}
    },
    {
        value: "HOURLY", label: "Hour", windowLabel: "Last 24 hours",
        window: {amount: 24, unit: "hours"}, step: {amount: 12, unit: "hours"}
    },
    {
        value: "DAYS", label: "Day", windowLabel: "Last 31 days",
        window: {amount: 31, unit: "days"}, step: {amount: 15, unit: "days"}
    },
];

export const DEFAULT_RESPONSE_TIME_PERIOD = "HOURLY";

// Picks the bucket size for a range so it stays well under the API limit of 2000 buckets
export const resolvePeriod = (start, end) => {
    const hours = end.diff(start, "hours", true);
    if (hours <= 2) return "MINUTES";
    if (hours <= 24 * 7) return "HOURLY";
    return "DAYS";
};

export const DashboardRepository = {
    // type: SPEECH_TO_TEXT | TEXT_TO_SPEECH | CHATBOT | ACTIVE_CALLS, period: MINUTES | HOURLY | DAYS
    getResponseTime: ({flowUid, type, period, start, end, signal}) =>
        axios.get(`/api/flow-statistic/${encodeURIComponent(flowUid)}/response-time`, {
            params: {type, period, start, end},
            signal
        }),
    // Number of conversations of the flow that are active right now (plain integer)
    getActiveCalls: ({flowUid, conversationType, signal}) =>
        axios.get(`/api/flow-statistic/${encodeURIComponent(flowUid)}/active-calls`, {
            params: {conversationType},
            signal
        }),
    // Returns every tag seen in the range; totals and item counts are keyed by tag uid
    getTagStatistic: ({flowUid, conversationType, period, start, end, signal}) =>
        axios.get(`/api/flow-statistic/${encodeURIComponent(flowUid)}/tags`, {
            params: {conversationType, period, start, end},
            signal
        }),
};
